import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApiAuthService } from './auth.service';
import { ApiAuthPermissionsDirective } from './auth-permission.directive';
import { ApiAuthStorageService } from './auth-storage.service';

@NgModule({
  declarations: [ApiAuthPermissionsDirective],
  imports: [CommonModule, RouterModule],
  exports: [ApiAuthPermissionsDirective],
})
export class ApiAuthModule {
  public static forRoot(): ModuleWithProviders<ApiAuthModule> {
    return {
      ngModule: ApiAuthModule,
      providers: [ApiAuthService, ApiAuthStorageService],
    };
  }
}
